import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer";

function RichTextDataDefinitionListItem({ blok }) {
  return (
    <React.Fragment key={blok._uid}>
      <dt>{blok.term}</dt>
      <dd>
        <RichTextWithBlokRenderer document={blok.definition} />
      </dd>
    </React.Fragment>
  );
}

export default RichTextDataDefinitionListItem;
